/**
 * Static-translations for ko. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const ko = {
  'anon.description_default': '게스트 세션을 설정 중…',
  'anon.heading_default': '게스트로 계속',
  'anon.try_again': '다시 시도',
  'auth.back_to_login': '로그인으로 돌아가기',
  'auth.check_email_message': '이메일에서 확인 코드를 확인하세요.',
  'auth.check_email_title': '이메일을 확인하세요',
  'auth.confirm_email_subtitle': '이메일로 보낸 코드를 입력하여 가입을 완료하세요.',
  'auth.confirm_email_title': '이메일 확인',
  'auth.confirmation_code': '확인 코드',
  'auth.continue_with_apple': 'Apple로 계속하기',
  'auth.continue_with_facebook': 'Facebook으로 계속',
  'auth.continue_with_github': 'GitHub로 계속',
  'auth.continue_with_google': 'Google로 계속하기',
  'auth.create_account': '계정 만들기',
  'auth.default_subtitle': '모든 기능에 액세스하고 데이터를 동기화하려면 로그인하세요.',
  'auth.email': '이메일 주소',
  'auth.email_already_registered': '이 이메일은 이미 등록되어 있습니다. 아래에서 비밀번호 또는 가입할 때 사용한 계정으로 로그인하세요.',
  'auth.email_exists': '이 이메일로 등록된 계정이 이미 있습니다.',
  'auth.email_not_confirmed': '먼저 이메일을 확인해 주세요.',
  'auth.forgot_password': '비밀번호를 잊으셨나요?',
  'auth.forgot_password_title': '비밀번호를 잊으셨나요?',
  'auth.forgot_subtitle': '이메일을 입력하시면 비밀번호 재설정 링크를 보내드립니다.',
  'auth.generic_error': '문제가 발생했습니다',
  'auth.have_account': '계정이 있으신가요?',
  'auth.hide_password': '비밀번호 숨기기',
  'auth.identity_already_linked': '이 계정은 이미 등록되어 있습니다. 아래에서 로그인하세요.',
  'auth.invalid_credentials': '잘못된 이메일 또는 비밀번호',
  'auth.invalid_otp': '코드가 잘못되었거나 만료되었습니다.',
  'auth.last_used': '최근 사용 · {email}',
  'auth.last_used_no_email': '최근 사용',
  'auth.link_purchase_subheading': '액세스를 유지하기 위해 구매를 계정에 연결합니다.',
  'auth.log_in': '로그인',
  'auth.log_in_link': '로그인',
  'auth.login_continue_purchase': '로그인하여 구매를 계속하세요',
  'auth.network_error': '네트워크 오류. 연결을 확인하고 다시 시도해 주세요.',
  'auth.new_password_optional': '새 비밀번호 (선택 — 비밀번호 재설정 시에만)',
  'auth.no_account': '계정이 없으신가요?',
  'auth.or': '또는',
  'auth.password': '비밀번호',
  'auth.passwords_mismatch': '비밀번호가 일치하지 않습니다',
  'auth.rate_limited': '요청이 너무 많습니다. 나중에 다시 시도해 주세요.',
  'auth.repeat_password': '비밀번호 재입력',
  'auth.reset_link_valid': '링크는 1시간 동안 유효합니다.',
  'auth.reset_password_subtitle': '이메일의 코드와 새 비밀번호를 입력하세요.',
  'auth.reset_password_title': '비밀번호 재설정',
  'auth.reset_sent_message': '해당 이메일이 존재하면 재설정 코드가 발송되었습니다.',
  'auth.reset_sent_subtitle': '비밀번호 재설정 링크를 보냈습니다. 이메일의 안내를 따라주세요.',
  'auth.restore_purchases_heading': '구매 복원',
  'auth.restore_purchases_subheading': '구매를 복원하려면 로그인하세요.',
  'auth.send_reset': '재설정 이메일 보내기',
  'auth.service_unavailable': '서비스를 일시적으로 이용할 수 없습니다. 잠시 후 다시 시도해 주세요.',
  'auth.show_password': '비밀번호 표시',
  'auth.sign_out': '로그아웃',
  'auth.sign_up': '회원가입',
  'auth.sign_up_link': '회원가입',
  'auth.signed_in': '로그인됨',
  'auth.signin_failed': '로그인 실패',
  'auth.signup_failed': '가입 실패',
  'auth.verify': '확인',
  'auth.weak_password': '비밀번호가 너무 약합니다.',
  'auth.welcome': '환영합니다!',
  'auth.welcome_signup': '환영합니다!',
  'countdown.d': '일',
  'countdown.h': '시',
  'countdown.m': '분',
  'countdown.s': '초',
  'cta.close': '닫기',
  'cta.continue': '계속',
  'cta.get_lifetime_access': '평생 이용권 받기',
  'cta.get_plan_daily': '일일 플랜 받기',
  'cta.get_plan_generic': '{interval} 플랜 받기',
  'cta.get_plan_monthly': '월간 플랜 받기',
  'cta.get_plan_weekly': '주간 플랜 받기',
  'cta.get_plan_yearly': '연간 플랜 받기',
  'cta.start_trial': '{days}일 무료 체험 시작',
  'modal.close_aria': '닫기',
  'modal.continue': '계속',
  'modal.error_generic': '문제가 발생했습니다',
  'modal.loading': '불러오는 중…',
  'modal.purchase_restored_subtitle': '모든 준비가 끝났어요 — 즐겨보세요!',
  'modal.purchase_restored_title': '다시 오신 것을 환영합니다',
  'modal.purchase_success_subtitle': '모든 준비가 끝났어요 — 즐겨보세요!',
  'modal.purchase_success_title': '결제가 완료되었습니다',
  'modal.verifying_subscription': '구독을 확인 중…',
  'nav.back': '← 뒤로',
  'nav.back_aria': '뒤로',
  'offer.limited_time': '한정 기간 제안',
  'payment.awaiting_subtitle': '결제를 자동으로 감지합니다 — 또는 완료되면 아래를 클릭하세요.',
  'payment.awaiting_title': '새 탭에서 결제를 완료하세요',
  'payment.checking': '확인 중…',
  'payment.ive_paid': '결제했습니다',
  'payment.open_checkout_again': '결제 다시 열기',
  'payment.open_checkout_button': '결제 열기',
  'payment.popup_blocked_message': '브라우저가 결제 탭을 차단했습니다. 아래를 클릭하여 열어주세요.',
  'payment.popup_blocked_title': '계속하려면 팝업을 허용하세요',
  'payment.popup_help_text': '결제 창이 열리지 않거나 차단되었나요? 여기를 클릭하여 다시 열어주세요.',
  'payment.still_processing': '결제가 아직 처리 중입니다. 잠시 후 다시 시도해 주세요.',
  'payment.tab_closed_retry': '탭을 닫았나요? 다시 시도',
  'pricing.free_trial_days': '{days}일 무료 체험',
  'pricing.included_per': '{interval}당 포함:',
  'pricing.interval.day': '일',
  'pricing.interval.lifetime_short': '평생',
  'pricing.interval.month': '월',
  'pricing.interval.period': '기간',
  'pricing.interval.week': '주',
  'pricing.interval.year': '년',
  'pricing.money_back': '30일 환불 보장',
  'pricing.most_popular': '가장 인기',
  'pricing.no_prices': '가격이 없습니다.',
  'pricing.plan_label.daily': '일일 플랜',
  'pricing.plan_label.lifetime': '평생',
  'pricing.plan_label.monthly': '월간 플랜',
  'pricing.plan_label.weekly': '주간 플랜',
  'pricing.plan_label.yearly': '연간 플랜',
  'pricing.plans_aria': '플랜',
  'session.contact_support': '지원팀에 문의',
  'session.restore_purchases': '구매 복원',
  'session.sign_out': '로그아웃',
  'session.signed_in_as_prefix': '로그인됨:',
  'session.signing_out': '로그아웃 중…',
  'support.attachments_aria': '첨부 파일 업로드',
  'support.attachments_label': '첨부 파일',
  'support.close_button': '닫기',
  'support.done_button': '완료',
  'support.dropzone_text': '여기에 이미지를 끌어다 놓거나 클릭하여 선택',
  'support.email_placeholder': '이메일 입력',
  'support.file_requirements': 'JPEG/PNG/WebP, 최대 {max}개, 각 {size}MB 이하',
  'support.heading': '지원',
  'support.instruction': '지원 요청을 제출하려면 아래 양식을 작성하세요.',
  'support.invalid_email': '유효하지 않은 이메일',
  'support.invalid_file': 'JPEG/PNG/WebP만, 각 {size}MB 이하',
  'support.message_length': '1~5000자',
  'support.message_placeholder': '메시지 입력',
  'support.remove_file_aria': '{filename} 제거',
  'support.required': '필수',
  'support.send_another': '다른 요청 보내기',
  'support.send_button': '보내기',
  'support.sending': '전송 중…',
  'support.sending_as': '발신:',
  'support.subject_length': '3~200자',
  'support.subject_placeholder': '제목 입력',
  'support.success_heading': '요청이 제출되었습니다',
  'support.success_message_prefix': '메시지를 받았습니다. 답장 주소:',
  'support.too_many_files': '최대 {max}개'
} as const;

export default ko;
